(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yengear-newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('[data-yengear-newsletter-section]');
  const quote = document.querySelector('.yg-quote');

  if (section && quote) {
    const quoteSection = quote.closest('section');
    if (quoteSection && quoteSection.parentNode && section !== quoteSection.previousElementSibling) {
      quoteSection.parentNode.insertBefore(section, quoteSection);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
